import { GALLERY_SCHEMA } from "../../consts/Template";
import Configs from "../../Configurations";
import imgPlaceholder from "../images/img-placeholder-half.svg";

const blob_url = Configs?.REACT_APP_IMAGE_STORAGE_URL || "https://blob.sparknotifications.walmart.com";

const TwoColumn = {
  [GALLERY_SCHEMA.ID]: "two_column",
  [GALLERY_SCHEMA.NAME]: "Two Column Layout",
  [GALLERY_SCHEMA.CATEGORY]: null,
  template_content: `<mjml>
  <mj-head>
    <mj-style>
      p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
      ul, ol { margin-block-start:0; margin-block-end:0; padding-block-start:0; padding-block-end:0; Margin:0; }
      @media only screen and (max-width: 480px) {
        .mj-column-per-48 div { text-align: center !important; }
        .mj-column-per-100 div { text-align: center !important; }
      }
    </mj-style>
  </mj-head>
  <mj-body background-color="#ffffff">
    <!-- Header Section - Walmart Spark Banner -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-image
          src="${blob_url}/templateeditortestteam-image/WMT-Spark-SparkYellow-RGB.png"
          width="40px"
          align="center"
          padding-top="32px"
          padding-bottom="32px"
          padding-left="0px"
          padding-right="0px"
          alt="Walmart Spark">
        </mj-image>
      </mj-column>
    </mj-section>

    <!-- Heading -->
    <mj-section
      padding-top="0px"
      padding-bottom="0px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <mj-column>
        <mj-text
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="24px"
          line-height="32px"
          color="#2E2F32">
          <span style="font-size:24px"><strong>Type your text here.</strong></span>
        </mj-text>
      </mj-column>
    </mj-section>

    <!-- Two Column Body -->
    <mj-section
      padding-top="0px"
      padding-bottom="24px"
      padding-left="24px"
      padding-right="24px"
      background-color="#ffffff">
      <!-- Column 1: Image top, text below -->
      <mj-column width="48%">
        <mj-image
          src="${imgPlaceholder}"
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32">
          <p>Lorem ipsum dolor sit amet consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32">
          <p>Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur amet consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
        </mj-text>
      </mj-column>
      <!-- Spacer column: ~4% gap -->
      <mj-column width="4%">
        <mj-text padding-top="0px" padding-bottom="0px" padding-left="0px" padding-right="0px" font-size="0px"> </mj-text>
      </mj-column>
      <!-- Column 2: Text top, image below -->
      <mj-column width="48%">
        <mj-text
          padding-top="0px"
          padding-bottom="8px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32">
          <p>Lorem ipsum dolor sit amet consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
        </mj-text>
        <mj-text
          padding-top="0px"
          padding-bottom="16px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32">
          <p>Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur amet consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
        </mj-text>
        <mj-image
          src="${imgPlaceholder}"
          padding-top="0px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px">
        </mj-image>
      </mj-column>
    </mj-section>

    <!-- Footer -->
    <mj-section
      padding-top="32px"
      padding-bottom="32px"
      padding-left="32px"
      padding-right="32px"
      background-color="#f3f3f3">
      <mj-column>
        <mj-social
          font-size="12px"
          border-radius="50%"
          mode="horizontal"
          padding-top="0px"
          padding-bottom="24px"
          padding-left="0px"
          padding-right="0px">
          <mj-social-element border-radius="50%" icon-size="32px" name="linkedin-noshare" src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" background-color="#0a66c2"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="twitter-noshare" src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" background-color="#000000"></mj-social-element>
          <mj-social-element border-radius="50%" icon-size="32px" name="workvivo-noshare" src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" background-color="#9966f5"></mj-social-element>
        </mj-social>
        <mj-divider
          border-width="1px"
          padding-left="0px"
          padding-right="0px"
          padding-top="0px"
          padding-bottom="0px"
          border-color="#e3e4e5">
        </mj-divider>
        <mj-text
          padding-top="24px"
          padding-bottom="0px"
          padding-left="0px"
          padding-right="0px"
          font-family="'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif"
          font-size="16px"
          line-height="24px"
          color="#2E2F32"
          align="center">
          <p style="text-align:center">Sent with Spark Notifications</p>
        </mj-text>
      </mj-column>
    </mj-section>
  </mj-body>
</mjml>`,
  [GALLERY_SCHEMA.PREVIEW]: `<!doctype html>
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1">
  <style type="text/css">
    body { margin: 0; padding: 0; }
    table, td { border-collapse: collapse; }
    img { border: 0; height: auto; line-height: 100%; outline: none; text-decoration: none; }
    p { display: block; margin: 13px 0; }
    p, li { line-height: 1.5; margin-top: 0; margin-bottom: 0; }
    ul, ol { margin-block-start: 0; margin-block-end: 0; padding-block-start: 0; padding-block-end: 0; Margin: 0; }
  </style>
</head>
<body style="word-spacing:normal;background-color:#ffffff;">
  <div style="background-color:#ffffff;">
    <!-- Header Section - Walmart Spark Banner -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:32px;padding-right:0px;padding-bottom:32px;padding-left:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;margin:0 auto;">
                          <tbody>
                            <tr>
                              <td style="width:40px;">
                                <img alt="Walmart Spark" src="${blob_url}/templateeditortestteam-image/WMT-Spark-SparkYellow-RGB.png" style="border:0;display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="40" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Heading -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:0px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:16px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:24px;line-height:32px;text-align:left;color:#2E2F32;"><span style="font-size:24px"><strong>Type your text here.</strong></span></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Two Column Body -->
    <div style="background:#ffffff;background-color:#ffffff;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#ffffff;background-color:#ffffff;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:24px;padding-left:24px;padding-right:24px;padding-top:0px;text-align:center;">
              <!-- Column 1: Image top, text below -->
              <div class="mj-column-per-48 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:48%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:16px;padding-left:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img alt="" src="${imgPlaceholder}" style="display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:8px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">
                          <p>Lorem ipsum dolor sit amet consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">
                          <p>Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur amet consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Spacer column: ~4% gap -->
              <div class="mj-column-per-4 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:4%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:Ubuntu, Helvetica, Arial, sans-serif;font-size:0px;line-height:1;text-align:left;color:#000000;"></div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <!-- Column 2: Text top, image below -->
              <div class="mj-column-per-48 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:48%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:8px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">
                          <p>Lorem ipsum dolor sit amet consectetur. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="left" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:16px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:left;color:#2E2F32;">
                          <p>Lorem ipsum dolor sit. Scelerisque orci aliquam commodo sit eleifend at commodo consectetur amet consectetur. Augue ultricies nunc senectus amet urna. Ut libero arcu aenean fermentum fermentum.</p>
                        </div>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="border-collapse:collapse;border-spacing:0px;">
                          <tbody>
                            <tr>
                              <td style="width:100%;">
                                <img alt="" src="${imgPlaceholder}" style="display:block;outline:none;text-decoration:none;height:auto;width:100%;font-size:13px;" width="100%" height="auto" />
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- Footer -->
    <div style="background:#f3f3f3;background-color:#f3f3f3;margin:0px auto;max-width:600px;">
      <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#f3f3f3;background-color:#f3f3f3;width:100%;">
        <tbody>
          <tr>
            <td style="direction:ltr;font-size:0px;padding:20px 0;padding-bottom:32px;padding-left:32px;padding-right:32px;padding-top:32px;text-align:center;">
              <div class="mj-column-per-100 mj-outlook-group-fix" style="font-size:0px;text-align:left;direction:ltr;display:inline-block;vertical-align:top;width:100%;">
                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="vertical-align:top;" width="100%">
                  <tbody>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:16px;padding-left:0px;word-break:break-word;">
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#0a66c2;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img alt="" src="${blob_url}/xmwrgbcr-image/kwwcuq26-linkedin-icon.png" style="border-radius:50%;display:block;" width="32" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#000000;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img alt="" src="${blob_url}/xmwrgbcr-image/kwwcupmb-twitter-icon.png" style="border-radius:50%;display:block;" width="32" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <table align="center" border="0" cellpadding="0" cellspacing="0" role="presentation" style="float:none;display:inline-table;">
                          <tbody>
                            <tr>
                              <td style="padding:4px;vertical-align:middle;">
                                <table border="0" cellpadding="0" cellspacing="0" role="presentation" style="background:#9966f5;border-radius:50%;width:32px;">
                                  <tbody>
                                    <tr>
                                      <td style="font-size:0;height:32px;vertical-align:middle;width:32px;">
                                        <img alt="" src="${blob_url}/xmwrgbcr-image/kwwbf659-workvivo-icon.png" style="border-radius:50%;display:block;" width="32" />
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:0px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <p style="border-top:solid 1px #e3e4e5;font-size:1px;margin:0px auto;width:100%;"></p>
                      </td>
                    </tr>
                    <tr>
                      <td align="center" style="font-size:0px;padding:10px 25px;padding-top:16px;padding-right:0px;padding-bottom:0px;padding-left:0px;word-break:break-word;">
                        <div style="font-family:'Everyday Sans UI', 'Everyday Sans', Arial, sans-serif;font-size:16px;line-height:24px;text-align:center;color:#2E2F32;">
                          <p style="text-align:center">Sent with Spark Notifications</p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</body>
</html>
`,
};
export default TwoColumn;
